// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from '@/vuex'
import router from './router'
import * as Sentry from '@sentry/vue'

// for vuetify
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'

// for c3
import 'c3/c3.min.css'

// for i18n
import { i18n } from '@/middlewares/i18n'

// for vue-meta
import Meta from 'vue-meta'

// scss
import '@/assets/styles/entry-point.scss'
// エラーハンドリング時の snackbar 用
import { snackbarType, actions } from '@/vuex/modules/ui/snackbar/constants'

// vue-material
import 'vue-material/dist/vue-material.min.css'
import { MdSwitch, MdField, MdIcon } from 'vue-material/dist/components'
import 'vue-material/dist/theme/default.css'

// Custom plugins
import ConfirmPlugin from '@/plugins/ConfirmPlugin'
import ConfirmPluginDelete from '@/plugins/ConfirmPluginDelete'
import GoogleAnalytics from '@/plugins/GoogleAnalytics'
import '@/plugins/Filter'

// Polyfills
import 'url-search-params-polyfill'

// 基底コンポーネント
const requireComponent = require.context('./components/App', true)
requireComponent.keys().forEach(fileName => {
  let baseComponentConfig = requireComponent(fileName)
  baseComponentConfig = baseComponentConfig.default || baseComponentConfig
  const baseComponentName =
    baseComponentConfig.name ||
    fileName.replace(/^.+\//, '').replace(/\.\w+$/, '')
  Vue.component(baseComponentName, baseComponentConfig)
})

Vue.config.productionTip = false
// Vue がキャッチできるエラー
Vue.config.errorHandler = (error, vm, info) => {
  const message = getErrorMessageFromErrorObject(error)
  store.dispatch(actions.SHOW_SNACKBAR, {
    type: snackbarType.ERROR,
    message: message,
  })

  console.error(vm, info)
}

// ハンドリングされているエラー
window.addEventListener('error', error => {
  const message = getErrorMessageFromErrorObject(error)
  store.dispatch(actions.SHOW_SNACKBAR, {
    type: snackbarType.ERROR,
    message: message,
  })

  console.error(error)
})

// ハンドリングされていないエラー
window.addEventListener('unhandledrejection', error => {
  const message = getErrorMessageFromErrorObject(error)
  if (message.includes('Avoided redundant navigation to current location'))
    return
  store.dispatch(actions.SHOW_SNACKBAR, {
    type: snackbarType.ERROR,
    message: message,
  })
  console.error(error)
})

/** dragイベントの禁止 */
window.addEventListener(
  'dragover',
  function(e) {
    e.preventDefault()
  },
  false,
)

/** dropイベントの禁止 */
window.addEventListener(
  'drop',
  function(e) {
    e.preventDefault()
    e.stopPropagation()
  },
  false,
)

const getErrorMessageFromErrorObject = error => {
  // PromiseRejectionEventオブジェクト(プロミスでエラーが起こった時に渡ってくるオブジェクト)の場合は
  // 以下のようにエラーメッセージを取得
  if (error.reason) {
    return error.reason.message
  }
  // 一般的なErrorオブジェクトの場合は以下のようにエラーメッセージを取得
  if (error.message) {
    return error.message
  }
}

// すべての広告主で共通して使われるテーマをここで指定
Vue.use(Vuetify, {
  theme: {
    earth: '#dfdfdf',
  },
})

Vue.use(Meta)
Vue.use(MdSwitch)
Vue.use(MdField)
Vue.use(MdIcon)
Vue.use(ConfirmPlugin)
Vue.use(ConfirmPluginDelete)
Vue.use(GoogleAnalytics)

Sentry.init({
  Vue,
  // dsn: process.env.VUE_APP_SENTRY_DSN,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: [
        'localhost',
        process.env.VUE_APP_CLIENT_URL_BASE,
        /^\//,
      ],
    }),
    // new Sentry.Replay(),
  ],
  environment: process.env.NODE_ENV,
  tracesSampleRate: 1.0,
  // replaysSessionSampleRate: 0.1,
  // replaysOnErrorSampleRate: 1.0,
})

/* eslint-disable no-new */
new Vue({
  i18n: i18n,
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
})
